import { CARD_SURFACE_CLASS } from '@/components/ui/Card';

interface StatCardProps {
  label: string;
  value: string;
  /** Optional second line below the value (context, comparison, unit, ...). */
  sub?: string;
  /** Text colour of the value, e.g. the P&L colour helpers. */
  valueClassName?: string;
  className?: string;
}

export default function StatCard({
  label,
  value,
  sub,
  valueClassName = 'text-gray-900 dark:text-white',
  className = '',
}: StatCardProps) {
  return (
    <div className={`${CARD_SURFACE_CLASS} p-4 ${className}`}>
      <div className="text-sm text-gray-500 dark:text-gray-400">{label}</div>
      <div className={`mt-1 text-2xl font-semibold ${valueClassName}`}>{value}</div>
      {sub !== undefined && <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">{sub}</div>}
    </div>
  );
}
